import * as React from 'react'

const EmptyState = ({ headerText, bodyText, ctaLink="/assign/diagnostic", ctaText='Browse diagnostics', }) => {
  return (
    <section className="empty-state">
      <h2>{headerText}</h2>
      <p>{bodyText}</p>
      <a className="quill-button green contained medium focus-on-light" href={ctaLink}>{ctaText}</a>
    </section>
  )
}

export default EmptyState
